import { render, staticRenderFns } from "./SearchProduct.vue?vue&type=template&id=881520b8&scoped=true&"
import script from "./SearchProduct.vue?vue&type=script&lang=js&"
export * from "./SearchProduct.vue?vue&type=script&lang=js&"
import style0 from "./SearchProduct.vue?vue&type=style&index=0&id=881520b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881520b8",
  null
  
)

export default component.exports